<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: [
    'id',
    'inverse'
  ],

  methods: {
    showModal: function (event) {
      $('#deleteTopologyModal'+this.id).modal('show')
    },

    deleteTopology: function (event) {
      window.location.href = Labstack.url + '/topologies/' + this.id + '/delete'
    },
  },

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
    }),

    reservationTopologyId: function () {
      if(this.reservation_transaction == undefined) {
        return null
      }

      return this.reservation_transaction.attributes.topology_blueprint_id
    },

    isDisabled: function () {
      return this.current.is_loading || this.id == this.reservationTopologyId
    }
  }
}
</script>

<template>
  <span>
    <a class="btn click-prevent"
      @click="showModal"
      :class="{ 'disabled': isDisabled, 'btn-danger': !inverse, 'btn-inverse btn-outline': inverse }"
    >
      <i class="fa fa-trash"></i>&nbsp;&nbsp;
      Delete
    </a>
    <div class="modal fade" :id="'deleteTopologyModal'+id" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content text-left">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">
              Delete Topology
            </h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
            Please confirm that you wish to delete topology #{{ id }}.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button"
              class="btn btn-danger"
              :class="{ 'disabled' : isDisabled }"
              @click.prevent="deleteTopology"
            >Yes</button>
            <button type="button"
              class="btn btn-default"
              :class="{ 'disabled' : isDisabled }"
              data-dismiss="modal"
            >No</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>
